/**
 * P4-11: Import 对话框。
 *
 * 取代 index.html `#importDiv`：
 * - 文本框 id 保持 `importData`，以便 `gamePage.saveImport()` 通过 jQuery 读取；
 * - Dropbox 导入按钮调用 `gamePage.saveImportDropbox()`；
 * - Import 按钮调用 `gamePage.saveImport()` 并关闭对话框。
 */
import { useRef } from "react";
import { t } from "../bridge/i18n";
import { useDialog } from "../components/Dialog";

function getGamePage() {
  return (globalThis as { gamePage?: { saveImport: () => void; saveImportDropbox: () => void } }).gamePage;
}

export default function ImportDialog() {
  const { closeTopDialog } = useDialog();
  const gamePage = getGamePage();
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleImport = () => {
    gamePage?.saveImport?.();
    closeTopDialog();
  };

  return (
    <div className="import-dialog">
      <div id="importWarning" className="import-warning">
        {t("save.import.warning")}
      </div>
      <h1 id="importFrom">{t("save.import.from")}</h1>
      <input
        id="importFromDropbox"
        type="button"
        value={t("save.import.dropbox")}
        onClick={() => gamePage?.saveImportDropbox?.()}
      />
      <br />
      <h1 id="importFromText">{t("save.import.text")}</h1>
      <br />
      <textarea
        id="importData"
        ref={textareaRef}
        style={{ width: "100%", minWidth: "320px", height: "220px" }}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
      />
      <br />
      <input
        id="doImportButton"
        type="button"
        value={t("ui.import")}
        style={{ marginTop: "10px" }}
        onClick={handleImport}
      />
      <input
        id="cancelButton"
        type="button"
        value={t("ui.cancel")}
        style={{ marginTop: "10px" }}
        onClick={closeTopDialog}
      />
    </div>
  );
}
